import type { FC } from 'react'
import LoginButton from '../../shared/LoginButton'
import PlaceholderKorag from '@g4g/ui/src/internal/PlaceholderKorag'

const RecipientOnboarding: FC = () => (
  <div className="lg:px-4 lg:pb-4">
    <PlaceholderKorag>Log in or search users to send a gift anonymously</PlaceholderKorag>
    <LoginButton primary />
  </div>
)

export default RecipientOnboarding
